/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderFxLauncherOptions } from './FxIdApplicationPublicDataBuilderFxLauncherOptions';
import {
    instanceOfFxIdApplicationPublicDataBuilderFxLauncherOptions,
    FxIdApplicationPublicDataBuilderFxLauncherOptionsFromJSON,
    FxIdApplicationPublicDataBuilderFxLauncherOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderFxLauncherOptionsToJSON,
} from './FxIdApplicationPublicDataBuilderFxLauncherOptions';

/**
 * @type FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptions
 * 
 * @export
 */
export type FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptions = FxIdApplicationPublicDataBuilderFxLauncherOptions;

export function FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsFromJSON(json: any): FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptions {
    return FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptions {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderFxLauncherOptions(json)) {
        return FxIdApplicationPublicDataBuilderFxLauncherOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptionsToJSONTyped(value?: FxIdApplicationPublicDataBuilderPublicDataBaseFxLauncherOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderFxLauncherOptions(value)) {
        return FxIdApplicationPublicDataBuilderFxLauncherOptionsToJSON(value as FxIdApplicationPublicDataBuilderFxLauncherOptions);
    }

    return {};
}

